import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseArticles } from "./UseArticles";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import DeleteRow from "../../components/DeleteRow";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import CheckIcon from "@mui/icons-material/Check";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CachedIcon from "@mui/icons-material/Cached";

export default function Articles() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { GetArticles, DeleteArticle, ResetCache } = UseArticles();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("Default", "Desc");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [articleRes, setArticleRes] = useState();
  const [deleteState, setDeleteState] = useState({
    show: false,
    name: undefined,
    id: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    GetArticles(search, myPc, true, (articles) => {
      if (msGotoLast) {
        setMsGotoLast(false);
        goToLastPage(articles.pageCondition.totalPage);
        return;
      }
      setArticleRes(articles);
    });
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/articles/addArticle", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 350,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "group",
      headerName: "گروه",
      width: 150,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography
            variant="span"
            sx={{ whiteSpace: "normal", direction: "rtl" }}
          >
            {cellValues.row.group}
          </Typography>
        );
      },
    },
    {
      field: "author",
      headerName: "نویسنده",
      width: 180,
      align: "left",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.author}
          </Typography>
        );
      },
    },
    {
      field: "isPublish",
      headerName: "منتشر شده",
      width: 90,
      align: "center",
      renderCell: (cellValues) => {
        return (
          <Box>
            {cellValues.row.isPublish ? (
              <CheckIcon style={{ color: "#618833" }} />
            ) : (
              <CloseOutlinedIcon style={{ color: "red" }} />
            )}
          </Box>
        );
      },
    },

    {
      field: "عملیات",
      sortable: false,
      width: 140,
      headerAlign: "center",
      align: "center",
      headerName: "عملیات",
      renderCell: (cellValues) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Tooltip title="حذف">
              <IconButton
                onClick={() => {
                  setDeleteState({
                    show: true,
                    name: cellValues.row.faName,
                    id: cellValues.row.id,
                  });
                }}
              >
                <DeleteIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ویرایش">
              <IconButton
                onClick={() => {
                  setScrollTo(cellValues.api.getScrollPosition());
                  return navigate("/articles/editArticle", {
                    state: {
                      myPc: myPc,
                      search: search,
                      id: cellValues.row.id,
                    },
                  });
                }}
              >
                <EditIcon sx={{ color: "MyColor.main" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="ریست کش">
              <IconButton
                sx={{ p: 0, m: 1 }}
                onClick={() => {
                  setProgress(true);
                  ResetCache(cellValues.row.id, () => {
                    setProgress(false);
                  });
                }}
              >
                <CachedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/articles" }],
      }}
    >
      {articleRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={articleRes.pageCondition.pageCount}
          rows={articleRes.articles}
          paginationMode="server"
          page={articleRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            articleRes?.pageCondition.totalItemCount
              ? articleRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              scrollTo: myPc.scrollTo,
              newFunc: newFunc,
              isLtr: true,
              rowCount: articleRes?.pageCondition.totalItemCount
                ? articleRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      <DeleteRow
        deleteState={deleteState}
        setDeleteState={setDeleteState}
        type={"مقاله "}
        callback={() => {
          setProgress(true);
          DeleteArticle(deleteState.id, () => {
            refresh();
          });
        }}
      ></DeleteRow>
    </Detail>
  );
}
